import { formatPost } from "../format-post";

export const POST = formatPost({
  form: "zyczenia",
  listed: { B1: true, B2: true },
  phrases: [
    ["Z okazji urodzin / imienin / Świąt…", "Z okazji jubileuszu / ślubu…"],
    ["życzę Ci / Pani / Panu…", "składam najserdeczniejsze życzenia…"],
    ["dużo zdrowia, szczęścia i radości", "sukcesów w pracy i spełnienia marzeń"],
    ["wszystkiego najlepszego!", "sto lat!"],
    ["Ściskam mocno / Całuję", "Z wyrazami szacunku / Z serdecznymi pozdrowieniami"],
  ],
  sample: `Szanowna Pani Haniu!
Z okazji osiemdziesiątych urodzin życzę Pani przede wszystkim dużo zdrowia, pogody ducha i wielu spokojnych, słonecznych dni. Dziękuję za wszystkie rozmowy na klatce i za pyszne ciasto. Sto lat!
Z serdecznymi pozdrowieniami
Marta z trzeciego piętra`,
  text: {
    pl: {
      title: "Jak napisać życzenia po polsku: urodziny, imieniny, jubileusz na egzamin",
      description: "Życzenia na egzamin państwowy: okazja, życzenia, jedno osobiste zdanie, pożegnanie. Formy „Ci” i „Pani”, zwroty i wzór życzeń urodzinowych.",
      lead: "Życzenia mają cztery części: zwrot do adresata, okazję („Z okazji urodzin…”), same życzenia („życzę Ci zdrowia i szczęścia”) i pożegnanie z podpisem. Jedno osobiste zdanie — podziękowanie, wspólne wspomnienie — odróżnia tekst od kartki ze sklepu. Do kolegi piszesz „Ci”, do sąsiadki czy dyrektora — „Pani”, „Panu” z 3. osobą.",
      summary: [
        "Cztery części: zwrot, okazja, życzenia, pożegnanie z podpisem; do tego jedno osobiste zdanie.",
        "„Życzę” wymaga dopełniacza: życzę zdrowia, szczęścia, sukcesów — nie „zdrowie”.",
      ],
      structureTitle: "Jak napisać życzenia krok po kroku?",
      structure: [
        "Zwrot: „Kochana Ciociu!”, „Drogi Tomku!”, „Szanowny Panie Dyrektorze!”.",
        "Okazja: „Z okazji urodzin / imienin / jubileuszu / Nowego Roku…”.",
        "Życzenia: „życzę Ci / Panu…” + dopełniacz: zdrowia, szczęścia, sukcesów, spełnienia marzeń.",
        "Jedno osobiste zdanie: podziękowanie, wspomnienie, zaproszenie.",
        "Pożegnanie i podpis: „Ściskam”, „Z serdecznymi pozdrowieniami”, „Z wyrazami szacunku”.",
      ],
      phrasesTitle: "Zwroty do życzeń",
      phrasesHead: ["Okazja i życzenia", "Dalsze życzenia i pożegnanie"],
      sampleTitle: "Wzór życzeń urodzinowych ({words})",
      sampleNote: "Okazja, życzenia w dopełniaczu, osobiste zdanie i forma „Pani” w całym tekście. Tekst jest nasz, nie z arkusza.",
      faq: [
        { q: "Życzę zdrowie czy zdrowia?", a: "Zdrowia: po „życzyć” rzecz stoi w dopełniaczu — życzę szczęścia, sukcesów, radości." },
        { q: "Jak zacząć życzenia do szefa?", a: "„Szanowny Panie Dyrektorze!” albo „Szanowna Pani Prezes!”, a dalej „Z okazji… składam Panu najserdeczniejsze życzenia…”." },
        { q: "Czym różnią się urodziny od imienin?", a: "Urodziny to dzień urodzenia, imieniny — dzień patrona imienia. W Polsce obchodzi się oba." },
      ],
      cta: { title: "Napisz życzenia na czas", text: "Część pisemna z prawdziwych arkuszy B1, a tekst ocenia model językowy. Jeden arkusz B1 jest bezpłatny." },
    },
    uk: {
      title: "Як написати życzenia польською: день народження, іменини, ювілей на іспит",
      description: "Życzenia на державний іспит: привід, побажання, одне особисте речення, прощання. Форми «Ci» і «Pani», звороти і зразок привітання.",
      lead: "Życzenia (привітання з побажаннями) мають чотири частини: звертання, привід («Z okazji urodzin…»), самі побажання («życzę Ci zdrowia i szczęścia») і прощання з підписом. Одне особисте речення — подяка, спільний спогад — відрізняє текст від листівки з магазину. До колеги пишеш «Ci», до сусідки чи директора — «Pani», «Panu» з 3-ю особою.",
      summary: [
        "Чотири частини: звертання, привід, побажання, прощання з підписом; плюс одне особисте речення.",
        "«Życzę» вимагає родового відмінка: życzę zdrowia, szczęścia, sukcesów — не «zdrowie».",
      ],
      structureTitle: "Як написати życzenia крок за кроком?",
      structure: [
        "Звертання: «Kochana Ciociu!», «Drogi Tomku!», «Szanowny Panie Dyrektorze!».",
        "Привід: «Z okazji urodzin / imienin / jubileuszu / Nowego Roku…».",
        "Побажання: «życzę Ci / Panu…» + родовий: zdrowia, szczęścia, sukcesów, spełnienia marzeń.",
        "Одне особисте речення: подяка, спогад, запрошення.",
        "Прощання й підпис: «Ściskam», «Z serdecznymi pozdrowieniami», «Z wyrazami szacunku».",
      ],
      phrasesTitle: "Звороти для życzeń",
      phrasesHead: ["Привід і побажання", "Інші побажання і прощання"],
      sampleTitle: "Зразок привітання з днем народження ({words})",
      sampleNote: "Привід, побажання в родовому, особисте речення і форма «Pani» в усьому тексті. Текст наш, не з набору.",
      faq: [
        { q: "Życzę zdrowie чи zdrowia?", a: "Zdrowia: після «życzyć» те, чого бажаєш, стоїть у родовому — życzę szczęścia, sukcesów, radości." },
        { q: "Як почати привітання керівникові?", a: "«Szanowny Panie Dyrektorze!» або «Szanowna Pani Prezes!», далі «Z okazji… składam Panu najserdeczniejsze życzenia…»." },
        { q: "Чим urodziny відрізняються від imienin?", a: "Urodziny — день народження, imieniny — день святого, чиє ім'я носиш. У Польщі святкують обидва." },
      ],
      cta: { title: "Напиши życzenia на час", text: "Письмова частина зі справжніх наборів B1, а текст оцінює мовна модель. Один набір B1 безкоштовний." },
    },
    ru: {
      title: "Как написать życzenia на польском: день рождения, именины, юбилей на экзамен",
      description: "Życzenia на государственный экзамен: повод, пожелания, одно личное предложение, прощание. Формы «Ci» и «Pani», обороты и образец поздравления.",
      lead: "Życzenia (поздравление с пожеланиями) состоят из четырёх частей: обращение, повод («Z okazji urodzin…»), сами пожелания («życzę Ci zdrowia i szczęścia») и прощание с подписью. Одно личное предложение — благодарность, общее воспоминание — отличает текст от открытки из магазина. Коллеге пишешь «Ci», соседке или директору — «Pani», «Panu» с 3-м лицом.",
      summary: [
        "Четыре части: обращение, повод, пожелания, прощание с подписью; плюс одно личное предложение.",
        "«Życzę» требует родительного падежа: życzę zdrowia, szczęścia, sukcesów — не «zdrowie».",
      ],
      structureTitle: "Как написать życzenia по шагам?",
      structure: [
        "Обращение: «Kochana Ciociu!», «Drogi Tomku!», «Szanowny Panie Dyrektorze!».",
        "Повод: «Z okazji urodzin / imienin / jubileuszu / Nowego Roku…».",
        "Пожелания: «życzę Ci / Panu…» + родительный: zdrowia, szczęścia, sukcesów, spełnienia marzeń.",
        "Одно личное предложение: благодарность, воспоминание, приглашение.",
        "Прощание и подпись: «Ściskam», «Z serdecznymi pozdrowieniami», «Z wyrazami szacunku».",
      ],
      phrasesTitle: "Обороты для życzeń",
      phrasesHead: ["Повод и пожелания", "Другие пожелания и прощание"],
      sampleTitle: "Образец поздравления с днём рождения ({words})",
      sampleNote: "Повод, пожелания в родительном, личное предложение и форма «Pani» во всём тексте. Текст наш, не из набора.",
      faq: [
        { q: "Życzę zdrowie или zdrowia?", a: "Zdrowia: после «życzyć» то, чего желаешь, стоит в родительном — życzę szczęścia, sukcesów, radości." },
        { q: "Как начать поздравление руководителю?", a: "«Szanowny Panie Dyrektorze!» или «Szanowna Pani Prezes!», дальше «Z okazji… składam Panu najserdeczniejsze życzenia…»." },
        { q: "Чем urodziny отличаются от imienin?", a: "Urodziny — день рождения, imieniny — день святого, чьё имя носишь. В Польше отмечают оба." },
      ],
      cta: { title: "Напиши życzenia на время", text: "Письменная часть из настоящих наборов B1, а текст оценивает языковая модель. Один набор B1 бесплатный." },
    },
    en: {
      title: "How to write życzenia in Polish: birthday, name-day and anniversary wishes",
      description: "Życzenia for the state exam: the occasion, the wishes, one personal line, a sign-off. \"Ci\" or \"Pani\", phrases and a model birthday card.",
      lead: "Życzenia (good wishes) have four parts: a greeting, the occasion (\"Z okazji urodzin…\"), the wishes themselves (\"życzę Ci zdrowia i szczęścia\") and a sign-off with your name. One personal sentence — a thank-you, a shared memory — is what sets the text apart from a shop-bought card. To a colleague you write \"Ci\"; to a neighbour or a director, \"Pani\", \"Panu\" with the third person.",
      summary: [
        "Four parts: greeting, occasion, wishes, sign-off with your name; plus one personal sentence.",
        "\"Życzę\" takes the genitive: życzę zdrowia, szczęścia, sukcesów — not \"zdrowie\".",
      ],
      structureTitle: "How do you write życzenia, step by step?",
      structure: [
        "Greeting: \"Kochana Ciociu!\", \"Drogi Tomku!\", \"Szanowny Panie Dyrektorze!\".",
        "Occasion: \"Z okazji urodzin / imienin / jubileuszu / Nowego Roku…\".",
        "Wishes: \"życzę Ci / Panu…\" + genitive: zdrowia, szczęścia, sukcesów, spełnienia marzeń.",
        "One personal sentence: a thank-you, a memory, an invitation.",
        "Sign-off and name: \"Ściskam\", \"Z serdecznymi pozdrowieniami\", \"Z wyrazami szacunku\".",
      ],
      phrasesTitle: "Phrases for życzenia",
      phrasesHead: ["Occasion and wishes", "More wishes and sign-off"],
      sampleTitle: "A model birthday card ({words})",
      sampleNote: "Occasion, wishes in the genitive, a personal line and \"Pani\" throughout. The text is ours, not a paper's.",
      faq: [
        { q: "Życzę zdrowie or zdrowia?", a: "Zdrowia: after \"życzyć\" what you wish takes the genitive — życzę szczęścia, sukcesów, radości." },
        { q: "How do you open wishes to a boss?", a: "\"Szanowny Panie Dyrektorze!\" or \"Szanowna Pani Prezes!\", then \"Z okazji… składam Panu najserdeczniejsze życzenia…\"." },
        { q: "What is the difference between urodziny and imieniny?", a: "Urodziny is your birthday, imieniny the day of the saint whose name you bear. Poles celebrate both." },
      ],
      cta: { title: "Write życzenia against the clock", text: "The writing part from real B1 papers, with your text marked by a language model. One B1 paper is free." },
    },
  },
});
